import React, { useState } from 'react';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { IMarketplaceTilesConfigComplexTag } from 'src/typings/marketplace';
import { readURL } from 'src/helpers';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import {
  useStyles,
} from './styles';

interface Props {
  item: IMarketplaceTilesConfigComplexTag,
  lang: string,
  onChange: (item: IMarketplaceTilesConfigComplexTag) => void,
}
export const ComplexTileTags: React.FC<Props> = ({ item, lang, onChange }) => {
  const [image, setImage] = useState<string | null>(item.iconFileUri?.fileUrl || null);
  const styles = useStyles();
  return (
    <div className={styles.TileTagWrapper}>
      <UploadMarketplace
        register={() => {}}
        registerName=""
        image={image}
        onUpload={async (file, response) => {
          onChange({ ...item, iconFileUri: response.data[0] });
          const base64: string = await readURL(file);
          if (base64) {
            setImage(base64);
          }
        }}
      />
      <BoxFormTextField
        label={translations.enterTagText}
        name="text"
        defaultValue={item.text?.[lang]}
        onChange={(event) => {
          onChange(updateTranslatedField(item, 'text', lang, event.target.value));
        }}
      />
    </div>
  );
};
